import Footer2 from "./FooterRGPD";

export default Footer2;
